import React from 'react';
import Typography from '@mui/material/Typography';
import styles from './styles';
import { consultTypeMapping } from '../const';

const RecommendationText = ({ medicalType, disease = null }) => {
    const classes = styles();
    const getMedicalTypeText = () => {
        const medicalTypeText = consultTypeMapping[medicalType];
        return !disease ? medicalTypeText : `${disease} ${medicalTypeText}`;
    };
    return (
        <div className={classes.mainHeader}>
            Recommendations for {getMedicalTypeText()}
        </div>
    );
};

export default RecommendationText;
